// src/pages/NotFoundPage.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Button from "../components/Button";
import "./NotFoundPage.css";
import PageHeader from "../components/PageHeader";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="notfound-container">
        <PageHeader
          title={t("notFound.title")}
          subtitle={t("notFound.description")}
        />
        <Button 
          label={t("notFound.homeButton")} 
          onClick={() => window.location.href = "/"} 
          type="button"
        />
      </div>
    </Layout>
  );
};

export default NotFoundPage;
